/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    name: 'c-user-info',
})

export default class UserInfo extends Vue {
    @Prop() private type!: string;
    @Prop() private counter!: string;
    @Prop() private username!: string;
    @Prop() private isAdmin!: boolean;
}

